import * as React from 'react';

const loadingGif = require('./loader.gif');

const Loader = (props: {}) => <img className="loader" src={loadingGif} />;

export class LoadHolder extends React.Component<{loading: boolean}, {}> {
  render() {
    const { loading, children } = this.props;
    return loading ? <Loader /> : (children || null);
  }
}

export { default as TableLoader } from './TableLoader';
export default Loader;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader/index.tsx